import { useSelector } from "react-redux";

export default function useGetMediaLocation() {
	const cloud = useSelector((state) => state.rundown.cloud);

	return cloud ? `` : `http://${window.location.hostname}/media/`;
}
